import NotificationBellBadge from './NotificationBellBadge';

export default NotificationBellBadge;
